import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m28.23 6.026.103.03.123.054.1.058.102.079.08.077q.048.054.09.114l.05.083.058.125.035.116.017.083.01.092L29 7v17a2 2 0 0 1-1.85 1.994L27 26H5a2 2 0 0 1-1.995-1.85L3 24V6.96l.012-.115.03-.135.038-.103.042-.086.075-.116.075-.091q.033-.035.07-.067l-.08.077q.047-.05.096-.091l.098-.072.088-.051.123-.053.13-.036.133-.019L4 6h24.037l.118.012zM27 9.272l-10.324 9.465a1 1 0 0 1-1.252.08l-.1-.08L5 9.273V24h22zM25.428 8H6.571l9.428 8.643z"
    />
  </svg>
);
const SvgIconEnvelopeSimple = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconEnvelopeSimple);
export default Memo;
